import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GoogleMap from '../Sections/ServiceAddress//GoogleMap';
import ServiceAddressSelector from '../Sections/ServiceAddress/ServiceAddressSelector';
import ConfirmAddress from '../Sections/ServiceAddress/ConfirmAddress';
import CheckAvailibility from '../Sections/ServiceAddress/CheckAvailibility';
import OffRamp from '../Sections/ServiceAddress/OffRamp';
import GasAccountLink from '../Sections/ServiceAddress/GasAccountLink';
import * as consts from '../../constants';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';

class ServiceAddress extends React.Component {
  constructor(props) {
        super(props);
        this.state = { isPopupLoaded: false, isShowGasAccountLink : false, isShowModalPopup : false , isPremiseLoaded : false };
    }
  componentWillReceiveProps(p) {   

       if(!p.offramp) {
         this.setState({ isPopupLoaded: false });
          this.setState({ isShowModalPopup: false });
         this.setState({ isShowGasAccountLink: false });
       }

       if(p.isProjectOffRamped && p.isActiveProject && !this.state.isPopupLoaded && !p.isResume) {
            this.setState({ isPopupLoaded: true });
            const modalLookup= window.osa && window.osa.commonLookup.modal;
            const data = {
                headerText: modalLookup.cancelService.header,
                bodyText: "This address already has a request for the service removal. <br /> If you wish to proceed, click Yes below. <br /> Otherwise you can call us at 1-888-224-2710 Monday - Friday 7 a.m. to 8 p.m. or click No.",
                actionButtonText: "No",
                closeButtonText: "Yes",
                onActionClicked: () => {
                    this.setState({ isShowModalPopup: true });
                }
            };
           this.props.dispatch({ type: 'SHOW_MODAL', data: data });
          
        }
        else if(p.isProjectOffRamped && p.isExisitngServiceOnLot && !this.state.isPopupLoaded && p.productName == consts.NEW_GAS_LINE_NAME && !p.isResume ) {
            this.setState({ isPopupLoaded: true });
            const modalLookup= window.osa && window.osa.commonLookup.modal;
            const data = {
                headerText: modalLookup.cancelService.header,
                bodyText: "This address already has an existing gas line, or request to add one has already been submitted.<br/> To start, stop, or move your gas account(the account you will be billed with) click Yes below. <br /> Otherwise, you can call us at 1-888-224-2710 Monday - Friday 7 a.m. to 8 p.m. or click No, complete the form and will call you.",
                actionButtonText: "Yes",
                closeButtonText: "No",
                onActionClicked: () => {
                    this.setState({ isShowGasAccountLink: true });
                }
            };
           this.props.dispatch({ type: 'SHOW_MODAL', data: data });
        }
      
        if(p.isResume &&   p.premiseNumber && p.productName == consts.SERVICE_REMOVAL_NAME && !this.state.isPremiseLoaded) {
            this.props.dispatch({ type: 'READ_PREMISE', premiseNumber: p.premiseNumber });
             this.setState({ isShowGasAccountLink: true });
        }

    }
  render() {
    const p = this.props;
    if (!window.osa) return null;
    const lookup =  window.osa && window.osa.lookup;
    const contactUsPhoneText = lookup.common && lookup.common.contactUsPhoneText;
    const errors = lookup && lookup.serviceAddress && lookup.serviceAddress.errors; 
    const errPinNotPlaced = errors && errors.pinNotPlacedOnLot + contactUsPhoneText;
    const errTechnical = errors && errors.technical + contactUsPhoneText;
    const errOutsideGasArea = errors && errors.outsideGasArea;
    const modalText = "You are being redirected to the FortisBC website <br/> (<a href='http://www.fortisbc.com'>www.fortisbc.com</a>)";
    const modalLookup= window.osa && window.osa.commonLookup.modal;
    return (
      <div>
        <Modal show={this.state.isShowModalPopup}>
              <Modal.Header>
                  <Modal.Title>{ modalLookup.cancelService.header}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                    <span dangerouslySetInnerHTML={{ __html: modalText }} />                       
              </Modal.Body>
              <Modal.Footer>
                    <Button bsStyle="primary" onClick={() => { window.location.href = 'http://www.fortisbc.com';}}>OK</Button>                     
              </Modal.Footer>
          </Modal>
        <GoogleMap  {...p} customAddress={p.customAddress} productName={this.props.productName} />
        {p.error ?
          <div>
            {p.isNoParcelFound ?
              <div >
                <div dangerouslySetInnerHTML={{ __html: errPinNotPlaced }} />
              </div>
              :
              <div className="animated-element animate-show">
                <div dangerouslySetInnerHTML={{ __html: errTechnical }} />
              </div>
            }
          </div>
          :
          <div>
            {p.isProjectOffRamped && p.productName == consts.SERVICE_REMOVAL_NAME ?
              <OffRamp  {...p} />
              :
              <div>
                {p.isOutsideGasArea ?
                  <div dangerouslySetInnerHTML={{ __html: errOutsideGasArea }} />
                  :
                  <div>
                    <ServiceAddressSelector lookup={lookup} isNoneSelected={p.isNoneSelected}
                      addressList={p.addressList} productName={p.productName} />
                    {p.productName == consts.NEW_GAS_LINE_NAME && 
                    <div>
                      <CheckAvailibility  {...p} />                      
                      {
                        p.isProjectOffRamped ? 
                          <div>
                            <br/> <br/>
                            {
                              this.state.isShowGasAccountLink ? <GasAccountLink />
                                                            : <OffRamp  {...p} productName={p.productName}/> 
                            }
                         </div>
                         : null
                      }
                    </div>
                    }
                    {p.productName == consts.SERVICE_REMOVAL_NAME && <ConfirmAddress  {...p} />}

                  </div>
                }
              </div>

            }
          </div>
        }
      </div>
    );
  }
}

ServiceAddress.propTypes = {
  id: PropTypes.string.isRequired,
  addressList: PropTypes.array,
  onNextClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  error: PropTypes.string,
  isNoParcelFound: PropTypes.bool,
  isProjectOffRamped: PropTypes.bool,
  offramp : PropTypes.object,
  isExisitngServiceOnLot : PropTypes.bool,
  isActiveProject : PropTypes.bool,
  isOutsideGasArea: PropTypes.bool,
  isNoneSelected: PropTypes.bool,
  isResume: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    addressList: state.gas.parcel && state.gas.parcel.addressList,
    error: state.gas.error,
    isProjectOffRamped: state.gas.offramp && state.gas.offramp.isSuccess,
    isExisitngServiceOnLot :  state.gas.offramp && state.gas.offramp.isExisitngServiceOnLot,
    isActiveProject :  state.gas.offramp && state.gas.offramp.isActiveProject,
    isOutsideGasArea: state.gas.parcel && state.gas.parcel.isOutsideGasArea,
    isNoParcelFound: state.gas.error && state.gas.error === 'no parcel found',
    isNoneSelected: (state.form.addressList == -1),
    customAddress: state.gas.customAddress,
    productName: state.gas.pageName,
    isResume : state.gas.isResume,
    offramp : state.gas.offramp,
    premiseNumber: state.gas.parcel && state.gas.parcel.data.premiseInfo && state.gas.parcel.data.premiseInfo.premiseNumber,
    //selectedAddress: state.form.addressList,
  };
}

export default connect(mapStateToProps)(ServiceAddress);



